import atmoClient from "@/setup/clients/atmoClient";
import RestClient from "@/api/utils/baseRestClient";

class SampleRestClient extends RestClient {
  async bulkCreate(form, config) {
    form = this.toSnake([...form]);
    const url = `${this.path}/bulk_create_or_update/`;
    const response = await this.client.post(url, form, config);
    return this.toCamel(response.data);
  }

  async bulkUpdate(form, config) {
    form = this.toSnake([...form]);
    const url = `${this.path}/bulk_create_or_update/`;
    const response = await this.client.post(url, form, config);
    return this.toCamel(response.data);
  }
}

export const sampleRestClient = new SampleRestClient(atmoClient, "samples");
